import { inject, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { PupilContext } from '../../pupil-context';
import { PupilContextActions } from './pupil-context.actions';
import * as PupilContextSelectors from './pupil-context.selectors';

@Injectable({
  providedIn: 'root',
})
export class PupilContextFacade {
  private readonly store: Store = inject(Store);

  public readonly pupilContext: Signal<PupilContext | undefined> =
    this.store.selectSignal(PupilContextSelectors.selectPupilContext);

  public readonly homiPersonId: Signal<string | undefined> =
    this.store.selectSignal(PupilContextSelectors.selectHomiPersonId);

  public readonly hasPupilContext: Signal<boolean> = this.store.selectSignal(
    PupilContextSelectors.selectHasPupilContext,
  );

  public setPupilContext(pupilContext: PupilContext | undefined): void {
    this.store.dispatch(PupilContextActions.setPupilContext({ pupilContext }));
  }
}
